//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Service from '@/service/public'
import WX_API from '@/utils/wx_api'
import { drawCircleRadius } from '@/common/utils/canvas'

import Btns from '../poster/_btns'

const CANVAS_WIDTH = 690
const CANVAS_HEIGHT = 1038

const isIOS = wx.getSystemInfoSync().system.substring(0, 3).toLowerCase() === 'ios'

const IMG_OPTION = {
    x: 0,
    y: 0,
    fileType: 'png',
    quality: 1
}

export default {
    props: {
        show: Boolean,
        consultant_id: String,
        consultant: Object,
        house: Object
    },
    data () {
        return {
            qrcode: '',
            show_tpl: 0,
            qrcodes: [],
            billboard_path: '',
            finished: false,
        }
    },
    mounted () {
        Promise.all([1, 2, 3].map(this.getQr)).then((res) => {
            this.qrcodes = res
            this.generateImg()
        })
    },
    components: {
        Btns
    },
    watch: {
        show (latest) {
            if (latest && !this.finished) {
                wx.showLoading({
                    title: '生成中'
                })
            }
        }
    },
    methods: {
        tapBillboard () {},
        hide () {
            this.$emit('hide')
        },
        saveFail () {
            wx.showToast({
                title: '保存图片出错，请重试',
                icon: 'none'
            })
        },
        async save () {
            try {
                await WX_API.saveImageToPhotosAlbum(this.billboard_path)
            } catch (err) {
                this.saveFail()
            }
            this.hide()
        },
        async generateImg () {
            const [headimg, crown, bgs, features, qrs, flgs] = await Promise.all([
                this.getHeadimg(),
                this.getCrownBg(),
                this.getBgImg(),
                this.getFeatureImg(),
                this.getQrImg(),
                this.getTypeImg()
            ])
            this.drawImg({
                crown,
                headimg,
                features,
                bgs,
                qrs,
                flgs
            })
        },
        getQr (index) {
            const id = this.consultant_id || this.consultant.id
            return Service.getSceneQr({
                scene: `ccb${index}_${id}`,
                jump_page: 'pages/index/main'
            }, false).then(({ qrcode }) => {
                return qrcode
            })
        },
        getCrownBg () {
            return WX_API.getImgInfo(`https://cdn.vip-wifi.com/fangchan/img/consultant-card/tpl/crown.png`).then(({ path}) => path)
        },
        getQrImg () {
            const { qrcodes } = this
            return Promise.all(qrcodes.map(WX_API.getImgInfo))
                .then(([qr1, qr2, qr3]) => {
                    return [qr1.path, qr2.path, qr3.path]
                })
        },
        getHeadimg () {
            if (this.consultant.weixin_headimgurl) {
                let current = this.consultant.weixin_headimgurl.replace(/132$/, 0).replace(/\?x\-oss\-process=image\/resize,w_\w*,h_\w*(\/format,(webp|jpg))?/, '')
                return WX_API.getImgInfo(current).then((res) => {
                    return res.path
                })
            }
        },
        async getFeatureImg () {
            const tpls = [
                ['layout', 'zone', 'policy', 'sunlight', 'vr', 'audio', 'building', 'web720'],
                ['layout-2', 'zone-2', 'policy-2', 'sunlight-2', 'vr-2', 'audio-2', 'building-2', 'web720-2'],
                ['layout-3', 'zone-3', 'policy-3', 'sunlight-3', 'vr-3', 'audio-3', 'building-3', 'web720-3']
            ]
            const getIcons = icons =>
                icons.map(icon =>
                    WX_API.getImgInfo(`https://cdn.vip-wifi.com/fangchan/img/consultant-card/tpl/${icon}.png`)
                        .then(({ path }) => path)
                )

            const tpl_icons = []

            for (let i = 0; i < tpls.length; i++) {
                const icons = tpls[i]
                const [layout, zone, policy, sunlight, vr, audio, building, web720] = await Promise.all(getIcons(icons))
                tpl_icons.push({
                    layout, zone, policy, sunlight, vr, audio, building, web720
                })
            }
            return tpl_icons
        },
        getBgImg () {
            const tpls = ['', 'tpl2-bg', 'tpl3-bg']
            return Promise.all(tpls.map(tpl => tpl && WX_API.getImgInfo(`https://cdn.vip-wifi.com/fangchan/img/consultant-card/tpl/${tpl}.png?v=2`)))
                .then(([bg1, bg2, bg3]) => {
                    return [bg1.path, bg2.path, bg3.path]
                })
        },
        getTypeImg () {
            const flgs = ['green-flg', 'type']
            return Promise.all(flgs.map(tpl => WX_API.getImgInfo(`https://cdn.vip-wifi.com/fangchan/img/consultant-card/${tpl}.png`)))
                .then(([flg1, flg2]) => {
                    return [flg1.path, flg2.path, flg2.path]
                })
        },
        changeTpl () {
            this.show_tpl = (this.show_tpl + 1) % 3
            this.getImgPath({
                canvasId: `canvas_${this.show_tpl + 1}`,
                width: CANVAS_WIDTH,
                height: CANVAS_HEIGHT
            }).then((path) => {
                this.billboard_path = path
            })
        },
        drawImg ({ headimg, crown, features, qrs, bgs, flgs }) {
            const methods = [this.drawTpl1, this.drawTpl2, this.drawTpl3]
            Promise.all(
                methods.map((method, i) => {
                    return method.call(this, {
                        crown,
                        bg: bgs[i],
                        flg: flgs[i],
                        qr: qrs[i],
                        feature: features[i],
                        headimg
                    })
                })
            ).then((res) => {
                return this.getImgPath({
                    canvasId: `canvas_${this.show_tpl + 1}`,
                    width: CANVAS_WIDTH,
                    height: CANVAS_HEIGHT
                }).then((path) => {
                    wx.hideLoading()
                    this.finished = true
                    this.billboard_path = path
                })
            }).catch(wx.hideLoading)
        },
        getImgPath (opt) {
            return new Promise((resovle, reject) => {
                wx.canvasToTempFilePath({
                    ...IMG_OPTION,
                    ...opt,
                    success: (res) => {
                        resovle(res.tempFilePath)
                    },
                    fail: reject
                }, this.$mp.component)
            })
        },
        getHouseFeatures () {
            const { activities, vr_resource, audios, vr_panorama_resource ,planar_graph_url} = this.house
            const features = [
                {
                    type: 'web720',
                    text: '航拍看房',
                    size: [36, 36],
                    show: vr_panorama_resource && Boolean(vr_panorama_resource.vr_panorama_url)
                },
                {
                    type: 'building',
                    text: '楼盘总平',
                    size: [36, 36],
                    show: planar_graph_url
                },
                {
                    type: 'vr',
                    text: 'VR看房',
                    size: [34, 23],
                    show: vr_resource.vr_photo_url
                },
                {
                    type: 'audio',
                    text: '语音讲盘',
                    size: [30, 30],
                    show: Boolean(audios && audios.length)
                },
                {
                    type: 'sunlight',
                    text: '日照模拟',
                    size: [31, 31],
                    show: activities && activities.length && activities.indexOf('sunlight') > -1
                },
                {
                    type: 'zone',
                    text: '区域分析',
                    size: [24, 26],
                    show: true
                },
                {
                    type: 'layout',
                    text: '户型解析',
                    size: [27, 27],
                    show: true
                },
                {
                    type: 'policy',
                    text: '政策解读',
                    size: [26, 26],
                    show: true
                }
            ]
            return features.filter(({ show }) => show)
        },
        drawTpl ({ id }, cb) {
            return () => {
                return new Promise((resovle, reject) => {
                    try {
                        const ctx = wx.createCanvasContext(id, this.$mp.component)
                        ctx.setFillStyle('#ffffff')
                        ctx.fillRect(0, 0, CANVAS_WIDTH, CANVAS_HEIGHT)
                        if (typeof cb === 'function') {
                            cb(ctx)
                        }
                        ctx.draw(true, () => {
                            resovle()
                        })
                    } catch (err) {
                        reject(err)
                    }
                })
            }
        },
        drawTpl1 ({ bg, flg, feature, headimg, qr }) {
            const { consultant } = this
            const CONTENT_LEFT = 40
            return this.drawTpl({
                id: 'canvas_1'
            }, (ctx) => {
                const HEADIMG_HEIGHT = 689
                const NAME_TOP = HEADIMG_HEIGHT + 32
                const QR_TOP = HEADIMG_HEIGHT + 38
                ctx.setTextBaseline('top')
                // draw headimg
                ctx.drawImage(headimg, 0, 0, CANVAS_WIDTH, HEADIMG_HEIGHT)
                // write name
                ctx.font = 'normal bold 46px PingFang SC'
                ctx.setFillStyle('#2E2E2E')
                const { width: name_width } = ctx.measureText(consultant.name)
                ctx.fillText(`${consultant.name}`, CONTENT_LEFT, NAME_TOP, name_width)
                const flg_left = CONTENT_LEFT + name_width + 18
                ctx.drawImage(flg, flg_left, 730, 121, 36)
                ctx.font = 'normal 22px PingFang SC'
                ctx.setFillStyle('#00AD82')
                ctx.fillText(`${consultant.type_name}`, flg_left + 16, NAME_TOP + 13, 88)
                // draw qr img
                ctx.drawImage(qr, 499, QR_TOP + 12, 136, 136)
                ctx.font = 'normal 24px PingFang SC'
                ctx.setFillStyle('#627E7A')
                ctx.fillText('成都购房通', 507, 882)
                // draw qr border
                const QR_BORDER_LEFT = 483
                const BORDER_RADIUS = 4
                const OR_BORDER_STRLE= 'rgba(151,151,151,0.15)'
                const QR_BORDER_WIDTH = 167
                const QR_BORDER_HEIGHT = 201
                const QR_BORDE_LINE = 4
                drawCircleRadius(ctx, {
                    style: OR_BORDER_STRLE,
                    left: QR_BORDER_LEFT,
                    top: QR_TOP,
                    width: QR_BORDER_WIDTH,
                    height: QR_BORDER_HEIGHT,
                    radius: BORDER_RADIUS,
                    line: QR_BORDE_LINE
                })

                // write info
                const INFO_WIDTH = 460
                const DETAIL_TOP = NAME_TOP + 85
                ctx.setFillStyle('#666666')
                ctx.font = 'normal 28px PingFang SC'
                ctx.fillText(`楼盘：${consultant.building_name}`, CONTENT_LEFT, DETAIL_TOP, INFO_WIDTH)
                ctx.fillText(`微信：${consultant.weixin_name}`, CONTENT_LEFT, DETAIL_TOP + 40, INFO_WIDTH)
                ctx.fillText(`手机：${consultant.mobile}`, CONTENT_LEFT, DETAIL_TOP + 80, INFO_WIDTH)

                // draw features
                const FEATURES_Y = 957
                const FEATURES_HEIGHT = 56
                ctx.setFillStyle('#FFF5E5')
                ctx.fillRect(40, FEATURES_Y, 610, FEATURES_HEIGHT)
                ctx.setTextBaseline('top')
                const features = this.getHouseFeatures().slice(0, 3)
                features.forEach(({type, text, size}, i) => {
                    const width = size[0]
                    const height = size[1]
                    const icon_y = FEATURES_Y + FEATURES_HEIGHT / 2 - height / 2
                    let left = 0
                    if (i === 0) {
                        left = 72
                    } else if (i === 1) {
                        left = 283
                    } else if (i === 2) {
                        left = 494
                    }
                    const text_left = left + width + 10
                    ctx.drawImage(feature[type], left, icon_y, width, height)
                    ctx.font = 'normal 22px PingFang SC'
                    ctx.setFillStyle('#D7AD64')
                    ctx.fillText(text, text_left, FEATURES_Y + 14)
                })

            })()
        },
        drawTpl2 ({ bg, flg, crown, headimg, feature, qr }) {
            const { consultant } = this
            return this.drawTpl({
                id: 'canvas_2'
            }, (ctx) => {
                const BG_HEIGHT = 827
                ctx.drawImage(bg, 0, 0, CANVAS_WIDTH, BG_HEIGHT)
                const MIDDLE_X = CANVAS_WIDTH / 2
                // draw headimg
                ctx.save()
                ctx.beginPath()
                ctx.arc(MIDDLE_X, 224, 110, 0, 2 * Math.PI)
                ctx.clip()
                ctx.drawImage(headimg, 236, 114, 220, 220)
                ctx.restore()
                ctx.drawImage(crown, 229, 91, 232, 249)
                // write name
                ctx.font = 'normal bold 32px PingFang SC'
                ctx.setFillStyle('#ffffff')
                ctx.setTextAlign('center')
                const { width: name_width } = ctx.measureText(consultant.name)
                ctx.fillText(`${consultant.name}`, MIDDLE_X, 388)
                // draw flg
                const flg_x = MIDDLE_X + name_width / 2 + 18
                ctx.drawImage(flg, flg_x, 361, 116, 36)
                ctx.font = 'normal 22px PingFang SC'
                ctx.setFillStyle('#B62F26')
                ctx.setTextAlign('left')
                ctx.fillText(`${consultant.type_name}`, flg_x + 16, 386, 88)
                // write info
                ctx.setTextAlign('center')
                ctx.setFillStyle('#ffffff')
                ctx.font = 'normal bold 32px PingFang SC'
                ctx.fillText(`微信：${consultant.weixin_name}`, MIDDLE_X, 476)
                ctx.fillText(`手机：${consultant.mobile}`, MIDDLE_X, 516)
                // write building name
                ctx.save()
                ctx.font = 'normal bold 56px PingFang SC'
                ctx.setTextBaseline('top')
                ctx.setFillStyle('#FFEFB7')
                ctx.setShadow(0, 2, 4, 'rgba(98, 56, 8, 0.5)')
                ctx.fillText(`${consultant.building_name}`, MIDDLE_X, 560)
                ctx.restore()
                // draw qr
                ctx.drawImage(qr, 125, 858, 148, 148)
                ctx.setFillStyle('#ACACAC')
                ctx.setTextAlign('left')
                ctx.setTextBaseline('top')
                ctx.font = 'normal 24px PingFang SC'
                ctx.fillText(`成都购房通  买房更轻松`, 323, 893)
                ctx.fillText(`关注我们了解更多`, 323, 939)

                // draw features
                this.drawTplFeature(ctx, feature, {
                    bg: 'rgba(255, 128, 56, 0.29)',
                    font: 'normal 22px PingFang SC',
                    fillStyle: '#FFEFB7',
                    start_x: 45,
                    start_y: 683
                })
            })()
        },
        drawTpl3 ({ bg, flg, headimg, crown, feature, qr }) {
            const { consultant } = this
            return this.drawTpl({
                id: 'canvas_3'
            }, (ctx) => {
                const MIDDLE_X = CANVAS_WIDTH / 2
                const BG_HEIGHT = 1038
                // draw headimg
                ctx.drawImage(bg, 0, 0, CANVAS_WIDTH, BG_HEIGHT)
                ctx.save()
                ctx.beginPath()
                ctx.arc(MIDDLE_X, 141 + 110, 110, 0, 2 * Math.PI)
                ctx.clip()
                ctx.drawImage(headimg, 236, 141, 220, 220)
                ctx.restore()
                ctx.drawImage(crown, 229, 118, 232, 249)
                
                // draw flg
                ctx.font = 'normal 22px PingFang SC'
                ctx.setFillStyle('#15B280')
                ctx.setTextAlign('center')
                ctx.fillText(` ${consultant.type_name}`, MIDDLE_X, 74)

                // write name
                ctx.font = 'normal bold 32px PingFang SC'
                ctx.setFillStyle('#ffffff')
                ctx.setTextAlign('center')
                const { width: name_width } = ctx.measureText(consultant.name)
                ctx.fillText(`${consultant.name}`, MIDDLE_X, 410)

                // write building name
                ctx.save()
                ctx.font = 'normal bold 50px PingFang SC'
                ctx.setFillStyle('#FFEFB7')
                ctx.setTextAlign('center')
                ctx.setShadow(0, 2, 4, 'rgba(98, 56, 8, 0.5)')
                ctx.setTextBaseline('top')
                ctx.fillText(`${consultant.building_name}`, MIDDLE_X, 447)
                ctx.restore()
                // write info
                ctx.setTextBaseline('top')
                ctx.font = 'normal bold 32px PingFang SC'
                ctx.setFillStyle('#ffffff')
                ctx.fillText(`微信：${consultant.weixin_name}`, MIDDLE_X, 529)
                ctx.fillText(`手机：${consultant.mobile}`, MIDDLE_X, 579)
                // footer bg
                ctx.setFillStyle('#ffffff')
                ctx.fillRect(16, 782, CANVAS_WIDTH - 16 * 2, 256 - 16)
                // draw qr
                ctx.drawImage(qr, 265, 800, 160, 160)
                ctx.setFillStyle('#333333')
                ctx.setTextAlign('center')
                ctx.setTextBaseline('top')
                ctx.font = 'normal bold 28px PingFang SC'
                ctx.fillText(`成都购房通`, MIDDLE_X, 970)
                // draw features
                this.drawTplFeature(ctx, feature, {
                    bg: 'rgba(0,140,117,0.63)',
                    font: 'normal 22px PingFang SC',
                    fillStyle: '#88FFD9',
                    start_x: 45,
                    start_y: 653
                })
            })()
        },
        drawTplFeature (ctx, feature, { start_x, start_y, bg, font, fillStyle }) {
            const TEXT_TOP = 55
            const TEXT_Y = start_y + TEXT_TOP
            ctx.fillStyle = bg
            ctx.fillRect(start_x, start_y, 600, 100)
            const features = this.getHouseFeatures().slice(0, 5)
            const feature_len = features.length
            const FEATURE_ITEM_WIDTH = 88
            const FEATURE_LEFT = features.length > 3 ? 69 : 185
            const FEATURE_ITEM_WIDTH_MARGIN = (CANVAS_WIDTH - FEATURE_LEFT * 2 - feature_len * FEATURE_ITEM_WIDTH) / (feature_len - 1)
            ctx.setTextAlign('center')
            ctx.setTextBaseline('top')
            let tmp_left = FEATURE_LEFT
            features.forEach(({type, text, size}, i) => {
                const width = size[0]
                const height = size[1]
                const img_left = tmp_left + FEATURE_ITEM_WIDTH / 2 - width / 2
                const icon_y = start_y + TEXT_TOP / 2 - height / 2
                ctx.drawImage(feature[type], img_left, icon_y, width, height)
                ctx.font = font
                ctx.setFillStyle(fillStyle)
                ctx.fillText(text, tmp_left + FEATURE_ITEM_WIDTH / 2, TEXT_Y, FEATURE_ITEM_WIDTH)
                tmp_left += FEATURE_ITEM_WIDTH  + FEATURE_ITEM_WIDTH_MARGIN
            })
        }
    }
}
